import { Node, UINode } from '../models/nodes.model'

/**
 * Flatten a node tree into a flat array of nodes.
 * The resulting UINodes are annotated with the path to the node.
 */
export function flattenNodes(
  nodes: Node[],
  parentPath: string[] = [],
): UINode[] {
  return nodes.reduce<UINode[]>((flattened, node) => {
    const path = [...parentPath, node.description]
    const children = flattenNodes(node.children ?? [], path)
    flattened.push({ node, path }, ...children)
    return flattened
  }, [])
}
